import { queryOptions, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../ApiProvider';
import { unwrap, type ApiClient } from '../client';
import type { components } from '../schema.gen';
import { queryKeys } from './keys';

export type Me = components['schemas']['Me'];
export type Role = Me['user']['roles'][number];

/** The signed-in user. Loading it also arms the client's CSRF token. */
export function meQuery(api: ApiClient) {
  return queryOptions({
    queryKey: queryKeys.me(),
    queryFn: async () => {
      const me = await unwrap(api.GET('/api/me'));
      api.setCsrfToken(me.csrfToken);
      return me;
    },
  });
}

export function useMe() {
  return useQuery(meQuery(useApiClient()));
}
